{
  document.querySelectorAll('.simple-schedule-hours').forEach(el => {
    // In preview mode the server-rendered content is authoritative — skip AJAX
    if (el.dataset.previewDatetime) return

    window.coolHelperFunctions?.coolAjax({ action: 'simple_schedule_hours' }, res => {
      if (res?.data?.html) el.innerHTML = res.data.html
    })
  })
}
